<era-pane>
  <h5 class="small-caps"
      i18n>Voice Roaming</h5>
  <form [formGroup]="voiceRoamingForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <div class="form-check form-switch">
        <input type="checkbox"
               class="form-check-input rounded-3"
               role="switch"
               formControlName="voiceRoamingEnabled"
               id="voiceRoamingEnabled" />
        <label class="form-check-label"
               for="voiceRoamingEnabled">Turn Voice Roaming {{ (voiceRoamingEnabled.valueChanges | async) ? 'On' : 'Off'
          }}</label>
        <small class="form-text text-muted">
          The voice roaming setting is only available on certain carriers. Disabling voice roaming also disables data
          roaming.
        </small>
      </div>
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!voiceRoamingForm.valid">Submit</button>
  </form>
</era-pane>